export default function isValidHostname(string) {
  const regex = RegExp(
    "^https?://(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]).)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$"
  );
  return regex.test(string);
}
